<template>
  <v-dialog v-model="open" @input="v => v || closeDialog()" max-width="500px">
    <v-card :key="keyComponent">
      <v-card-title v-if="fieldText">{{ fieldText | translate }}</v-card-title>
      <v-card-text class="pb-0" v-if="sliderValues && !checkField()">
        <v-layout v-if="fieldDesc" row wrap align-center>
          {{ fieldDesc | translate }}
        </v-layout>
        <v-layout row wrap align-center>
          <span>
            {{ "lng_valid_interval" | translate }}
            {{`${parseMinMaxVal(sliderValues.min)} - ${parseMinMaxVal(sliderValues.max)}`}}
          </span>
        </v-layout>
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center class="text-field-cont">
            <p
              class="marked-value"
              v-if="!startTyping"
              v-on:click="startTyping = true"
            >
              <span style="background-color: #b3d4fb;">{{
                inputValue | onSliderTempConversion
              }}</span>
            </p>
            <v-text-field
              v-else
              autofocus
              v-model="inputValue"
              class="mt-0 pt-0"
              :value="sliderValues.val | onSliderTempConversion"
              @input="checkTextFieldValue(inputValue)"
              v-on:keyup.enter="saveFieldData"
            ></v-text-field>
            <!-- <v-icon right class="top-arrow" @click="addInValue(rangeValue)">arrow_drop_up</v-icon>
            <v-icon right class="bottom-arrow" @click="subtractInValue(rangeValue)">arrow_drop_down</v-icon> -->
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap align-center>
          <v-flex xs1 md1 align-content-center>{{
            sliderValues.min | tempConversion
          }}</v-flex>
          <v-flex xs10 md10>
            <v-slider
              v-model="rangeValue"
              :value="sliderValues.val | tempConversion"
              :step="getStep(sliderValues.factor)"
              :max="sliderValues.max"
              :min="sliderValues.min"
              @input="checkSliderValue(rangeValue)"
              @start="startChangeSliderValue(rangeValue)"
              @end="endChangeSliderValue(rangeValue)"
              @click="onClick(rangeValue)"
            ></v-slider>
          </v-flex>
          <v-flex xs1 md1 align-content-center text-xs-right>{{
            sliderValues.max | tempConversion
          }}</v-flex>
        </v-layout> -->
      </v-card-text>
      <p class="error-text">
        <span v-if="wrongValue">
          {{ "lng_not_valid_interval" | translate }}
          {{
            `${parseMinMaxVal(sliderValues.min)} - ${parseMinMaxVal(
              sliderValues.max
            )}`
          }}
        </span>
      </p>
      <v-card-text class="pb-0" v-if="sliderValues && checkField()">
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center>
            <v-text-field
              class="mt-0 pt-0"
              :value="sliderValues.val"
              v-model="sliderValues.val"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="closeDialog()"
              >Cancel</v-btn
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              :class="[wrongValue ? 'disabled-btn' : 'primary-btn']"
              block
              flex
              xs12
              flat
              :disabled="wrongValue"
              @click="saveFieldData()"
              >Save</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service.js";

export default {
  name: "SliderRangeDialog",
  data() {
    return {
      open: false,
      sliderValues: undefined,
      inputValue: undefined,
      wrongValue: false,
      rangeValue: undefined,
      savedTextFieldValue: undefined,
      savedSliderValue: undefined,
      startTyping: false
    };
  },
  props: {
    keyComponent: {
      type: Number,
      default: 0
    },
    valueObj: {
      type: Object,
      default: undefined
    },
    dialog: {
      type: Function,
      default: undefined
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    fieldText: {
      type: String,
      default: ""
    },
    fieldUdp: {
      type: String,
      default: ""
    },
    fieldDesc: {
      type: String,
      default: ""
    },
    selectedLanguage: {
      type: String,
      default: ""
    },
    onResponse: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  mounted() {
    let that = this;
    this.sliderValues = this.valueObj;
    document.addEventListener("keypress", function onEvent(event) {
      if (!that.startTyping) {
        that.inputValue = "";
        that.startTyping = true;
      }
    });
  },
  methods: {
    checkField() {
      return (
        this.fieldUdp === "notify.email" || this.fieldUdp === "notify.phone"
      );
    },
    closeDialog() {
      // A prop function to open or close modal
      this.startTyping = false;
      this.inputValue = this.valueObj.val;
      this.rangeValue = this.valueObj.val;
      this.wrongValue = false;
      this.savedTextFieldValue = this.valueObj.val;
      this.dialog(false);
    },

    parseMinMaxVal(val) {
      val = parseFloat(val);
      if (this.getStep(this.sliderValues.factor) === 1) {
        return val.toFixed(0);
      } else if (this.getStep(this.sliderValues.factor) === 0.1) {
        return val.toFixed(1);
      } else if (this.getStep(this.sliderValues.factor) === 0.01) {
        return val.toFixed(2);
      }
    },
    getSteppedParsedVal(val) {
      let step = this.getStep(this.sliderValues.factor);
      return step === 0.01 ? Number(val.toFixed(2)) : Number(val.toFixed(1));
    },

    noPrecision(val) {
      if (val.includes(",") || val.includes(".")) {
        this.wrongValue = true;
      } else {
        this.inputValue = val;
        this.savedTextFieldValue = val;
        this.updateSliderValue(val);
      }
    },
    hasPrecision(val, precisionVal) {
      if (val.includes(",") || val.includes(".")) {
        let tempArray = val.includes(",") ? val.split(",") : val.split(".");
        if (tempArray[1].length > precisionVal) {
          this.wrongValue = true;
        } else {
          this.inputValue = val;
          this.savedTextFieldValue = val;
          this.updateSliderValue(val);
        }
      } else {
        this.inputValue = val;
        this.savedTextFieldValue = val;
        this.updateSliderValue(val);
      }
    },

    checkTextFieldValue(val) {
      if (val) {
        // if(this.getStep(this.sliderValues.factor) === 1){
        //   if(val.includes(",") || val.includes(".")){
        //     this.wrongValue = true;
        //   } else {
        //     this.inputValue = val;
        //     this.savedTextFieldValue = val;
        //     this.updateSliderValue(val);
        //   }
        // } else {
        //   this.inputValue = val;
        //   this.savedTextFieldValue = val;
        //   this.updateSliderValue(val);
        // }
        if (this.getStep(this.sliderValues.factor) === 1) {
          this.noPrecision(val);
        } else if (this.getStep(this.sliderValues.factor) === 0.1) {
          this.hasPrecision(val, 1);
        } else if (this.getStep(this.sliderValues.factor) === 0.01) {
          this.hasPrecision(val, 2);
        }
      } else {
        this.wrongValue = true;
      }
    },
    addInValue(val) {
      let updatedValue =
        parseFloat(val) + this.getStep(this.sliderValues.factor);
      let updatedValue1 = this.getSteppedParsedVal(updatedValue);
      this.onClick(updatedValue1);
    },
    subtractInValue(val) {
      let updatedValue =
        parseFloat(val) - this.getStep(this.sliderValues.factor);
      let updatedValue1 = this.getSteppedParsedVal(updatedValue);
      this.onClick(updatedValue1);
    },
    onClick(val) {
      let step = this.getStep(this.sliderValues.factor);
      if (val <= this.sliderValues.max && val >= this.sliderValues.min) {
        this.sliderValues.val = val;
        this.rangeValue = val;
        if (
          this.savedTextFieldValue &&
          this.savedTextFieldValue.includes(",")
        ) {
          let parsedValue = val.toString().replace(".", ",");
          let tempStr = parsedValue.includes(",")
            ? parsedValue
            : parsedValue + ",0";
          let num = tempStr.toString().split(",");
          this.inputValue =
            step === 0.01 && num[1].length < 2 ? tempStr + "0" : tempStr;
        } else {
          let tempStr = val.toString().includes(".")
            ? val
            : this.getSteppedParsedVal(parseFloat(val)) + ".0";
          let num = tempStr.toString().split(".");
          this.inputValue =
            step === 0.01 && num[1].length < 2 ? tempStr + "0" : tempStr;
        }
      }
    },
    startChangeSliderValue(val) {
      this.savedSliderValue = true;
    },
    endChangeSliderValue(val) {
      this.savedSliderValue = undefined;
    },
    checkSliderValue(val) {
      let step = this.getStep(this.sliderValues.factor);
      if (isNaN(val)) {
        this.wrongValue = true;
      } else if (val > this.sliderValues.max || val < this.sliderValues.min) {
        this.wrongValue = true;
      } else {
        this.wrongValue = false;
        this.sliderValues.val = val;
        // this.rangeValue = val;
        if (this.savedSliderValue) {
          if (
            this.savedTextFieldValue &&
            this.savedTextFieldValue.includes(",")
          ) {
            let parsedValue = val.toString().replace(".", ",");
            let tempStr = parsedValue.includes(",")
              ? parsedValue
              : parsedValue + ",0";
            let num = tempStr.toString().split(",");
            this.inputValue =
              step === 0.01 && num[1].length < 2 ? tempStr + "0" : tempStr;
          } else {
            let tempStr = val.toString().includes(".")
              ? val
              : this.getSteppedParsedVal(parseFloat(val)) + ".0";
            let num = tempStr.toString().split(".");
            this.inputValue =
              step === 0.01 && num[1].length < 2 ? tempStr + "0" : tempStr;
          }
        } else {
          this.inputValue = this.savedTextFieldValue;
        }
      }
    },
    updateSliderValue(value) {
      let val = value.toString().replace(",", ".");
      if (isNaN(val)) {
        this.wrongValue = true;
      } else if (val > this.sliderValues.max || val < this.sliderValues.min) {
        this.wrongValue = true;
      } else {
        this.wrongValue = false;
        this.sliderValues.val = val;
        if (val.indexOf(".") !== val.length - 1) {
          this.rangeValue = val;
        }
      }
    },
    getStep(factor) {
      if (factor == 10) {
        return 0.1;
      } else if (factor == 100) {
        return 0.01;
      } else {
        return 1;
      }
    },
    // function for update field data
    async saveFieldData() {
      let response;
      let parsedValue = this.getSteppedParsedVal(
        parseFloat(this.sliderValues.val)
      );
      if (isNaN(parsedValue) || this.checkField()) {
        parsedValue = this.sliderValues.val;
      }
      try {
        response = await GlobalService.saveFieldData(
          this.fieldUdp,
          this.fieldUdp,
          this.getUser.token,
          parsedValue
        );
      } catch (e) {
        var resObj = { status: 1, message: "Try again later" };
        // A prop function to show alert dialog
        this.onResponse(resObj);
        // A prop function to open or close modal
        this.dialog(false);
      }
      if (response.onlineandsaved) {
        this.onResponse(response);
        this.startTyping = false;
        this.inputValue = parsedValue;
        this.rangeValue = parsedValue;
        this.wrongValue = false;
        this.savedTextFieldValue = parsedValue;
        this.valueObj.val = parsedValue;
        this.dialog(false);
      } else {
        this.onResponse(response);
        this.closeDialog();
      }
      // this.savedTextFieldValue = parsedValue;
      // this.dialog(false);
    }
  },
  watch: {
    openDialog(newVal) {
      this.open = newVal;
    },
    // prop object for field values
    valueObj(newVal) {
      this.sliderValues = Object.assign({}, newVal);
      this.inputValue = this.sliderValues.val;
      this.rangeValue = this.sliderValues.val;
    }
  }
};
</script>
<style>
.v-card__title {
  background-color: rgb(84, 110, 122);
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 400;
  width: 100%;
  height: 64px;
  max-height: 64px;
  padding: 0 16px;
  margin: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-dialog {
  border-radius: 4px;
  overflow: hidden;
}
.raised-btn {
  background-color: rgb(250, 250, 250);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
.disabled-btn {
  background-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}
.theme--light.v-btn svg {
  fill: #455a64;
}
.error-text {
  font-size: 14px;
  padding: 0;
  margin: 0;
  color: red;
  text-align: center;
  height: 24px;
}
.text-field-cont {
  position: relative;
}
.text-field-cont i {
  position: absolute;
  opacity: 0.5;
  cursor: pointer;
  height: 12px;
  right: 0;
  overflow: hidden;
  user-select: none;
}
.text-field-cont .v-input__slot {
  padding-right: 25px;
}
.top-arrow {
  top: 4px;
}
.bottom-arrow {
  top: 15px;
}
.text-field-cont i:hover {
  opacity: 1;
}
.marked-value {
  border-bottom: 1px solid;
  padding-bottom: 5px;
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
